{
  "SignInWith_Title": "Sign in with",
  "SignInWith_OtherOptions": "Sign in using other options",
  "NAME": "SignInWith"
}